import { format, parse } from "date-fns"
import { de, enGB } from "date-fns/locale"

export const isIsoDate = (e: string) => {
  if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(e)) return false
  var d = new Date(e)
  return d.toISOString() === e
}

export const formatLocaleDate = (
  lang: string,
  date: Date | string | number | undefined,
  dateFormat?: string,
) => {
  let locale = enGB
  if (lang === "de") {
    locale = de
  }
  if (!date) return ""

  return format(new Date(date), dateFormat ?? "dd/M/yyyy  hh:mm", {
    locale,
  })
}

// converts a german date string to an english date string
export const convertToEnDateString = (
  dateStr: string,
  locale: "de" | "en",
): string => {
  if (locale === "en") {
    // early return, since datestr is already in correct format
    return dateStr
  }
  return parse(dateStr, "d. MMMM yyyy HH:mm", new Date(), {
    locale: de,
  }).toString()
}
